import React from 'react';
import CouponComponent from '../components/Coupon';
import ShareModalComponent from '../components/ShareModal';
import { Box, Row, Col, Text } from 'tailwind-react-ui';

const ShareCouponSection = () =>{

    const [showModal, setShowModal] = React.useState(false);

    return(
        <Box id="compartir-cupon" bg={'dark-purple'}>
            <Box className="landing-container">
                <Row className="md:flex-row-reverse" id="share-coupon-row">
                    <Col p={1} className="w-full sm:w-full md:w-full lg:w-5/12">
                        <Box>
                            <Text 
                            is="h2" 
                            m={{b: 5}} 
                            className="quicksand-bold md:text-left lg:text-right" 
                            tracking={'wide'}
                            leading={'none'} 
                            text={['white', '4xl']}>
                                COMPARTE CON
                                <Text 
                                tracking={'wider'}
                                className="quicksand-bold block md:text-left lg:text-right" 
                                leading={'none'} 
                                text={['yellow', '5xl']}>
                                    TUS AMIGOS
                                </Text>
                            </Text>
                            <Text id="disponibility" is="p" className="quicksand-regular hidden lg:block" tracking={'widest'} text={['white', 'right', 'sm']}>
                                *Chelas sujeto a disponibilidad
                            </Text>
                        </Box>
                    </Col>
                    <Col p={1} className="w-full sm:w-full md:w-full lg:w-7/12">
                        <Box>
                            <Text is="p" className="quicksand-regular tracking-wide" text={['white', 'xl']}>
                                Una de las ventajas de está promoción es compartir <b>2 CHELAS GRATIS</b> con todos tus amigos.
                            </Text>
                            <CouponComponent 
                            id={'shareCoupon'} 
                            w={'full'} 
                            m={{t: 4, r: 64}} 
                            type={'share'} 
                            onClick={() => setShowModal(true)}/>
                        </Box>
                    </Col>
                </Row>
                <Text is="p" className="quicksand-regular lg:hidden" tracking={'widest'} text={['white', 'left', 'sm']}>
                    *Chelas sujeto a disponibilidad
                </Text>
            </Box>
            <ShareModalComponent showModal={showModal} setShowModal={(show) => setShowModal(show)}/>
        </Box>
    );
}

export default ShareCouponSection;